import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const MainContainer = styled.main`
  padding: 16px;
  box-shadow: ${palette.lightBS};
  cursor: pointer;
  width: 80%;
  height: 7vh;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: grid;
  grid-gap: 10px;
  transition-duration: 2s;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    transition-duration: 2s;
  }
  h6,
  span {
    text-align: center;
  }
  h6 {
    font-size: 14px;
    font-family: ${palette.nereg};
    font-weight: bold;
  }
  span {
    text-transform: capitalize;
    display: block;
    margin-top: 8px;
    font-family: ${palette.nereg};
  }
`;

const UserCard = (props) => {
  const { user, editUser } = props;
  const [state, setState] = React.useState({
    showType: '',
    name: '',
  });
  const { t } = useTranslation(['admin']);
  React.useEffect(() => {
    let showType;
    switch (user.levelPermission) {
      case 1:
        showType = t('Recruiter');
        break;
      case 0:
        showType = t('User');
        break;
      default:
        showType = 'Admin';
    }
    setState((prev) => ({ ...prev, ...user, showType }));
  }, [user]);
  return (
    <MainContainer onClick={() => editUser(user)}>
      <h6 className="text-center">
        {state.names} {state.lastNames}
      </h6>
      <span className="text-center">{state.showType}</span>
    </MainContainer>
  );
};

UserCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
  editUser: PropTypes.func,
};

UserCard.defaultProps = {
  user: {},
  editUser: () => {},
};

export default UserCard;
